import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import { Translate } from '../../language';
import logoRecoverPassword from '../../img/logo_final_png.png';
import { connect } from 'react-redux'
import { sendEmail } from '../../actions/regiterActions'
import ViewLogin from '../../containers/ViewLogin/ViewLogin';
//import $ from 'jquery';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})


const RegisterEmail = ({ sendEmail, history, errorType, success, location }) => {
    var model = location.state.model
    const [email, setEmail] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)


    useEffect(() => {
        var emailVar = 'email'
        setError(prevError => ({
            ...prevError,
            [emailVar]: ''
        }));

        if (errorType !== null && errorType.msg === "ya existe una cuenta para " + email) {
            console.log()
            setError(prevError => ({
                ...prevError,
                [emailVar]: Translate('ERRXXX', 'es')
            }));
        }

        if (errorType !== null && errorType.code === "ERR005") {
            setError(prevError => ({
                ...prevError,
                [emailVar]: Translate('ERR005', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR011") {
            setError(prevError => ({
                ...prevError,
                [emailVar]: Translate('ERR011', 'es')
            }));
        }

        if (errorType !== null && errorType.code === "ERR095") {
            Toast.fire({
                icon: 'error',
                title: 'Ya existe un usuario con ese correo'
            })
            setError(prevError => ({
                ...prevError,
                [emailVar]: Translate('ERR095', 'es')
            }));
        }

        if (errorType !== null && errorType.code === "ERR034") {
            setError(prevError => ({
                ...prevError,
                [emailVar]: Translate('ERR034', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR058") {
            setError(prevError => ({
                ...prevError,
                [emailVar]: Translate('ERR058', 'es')
            }));
        }


    }, [errorType])

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const isEmpty = (e) => {

        const { name, placeholder, value } = e.target;
        setEmail(value)
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }

        else if (value.length !== 0 && name === "email") {
            if ((value.includes("@") && value.includes(".")) === false) {
                setValidate(false)
                setError(prevError => ({
                    ...prevError,
                    [name]: Translate('invalidEmail', 'es')
                }));
            }
            else {
                setValidate(true)
                setError(prevError => ({
                    ...prevError,
                    [name]: ''
                }));
            }
        }
    }

    const goToLoginCode = (e) => {
        e.preventDefault()
        sendEmail(email, history, model)
        if (success === true) {
         //   $(document).ready(function () {
                // Show the Modal on load
           //     $("#myModal").modal("show");

                // Hide the Modal

            //});
        }
    }

    return (

        <ViewLogin
            type='email'
            nameInput='email'
            img={logoRecoverPassword}
            inputValue={email}
            error={error.email}
            onChangeInput={isEmpty}
            onFocusInput={isFocused}
            inputPlaceholder="enterEmail"
            textButton="send"
            actionButton={goToLoginCode}
            textDown=''
            TextlinkDown=''
            linkToDown=''
            isMenuDown={true}
            isBackgroundBlue={false}
            isActiveButton={isValidate}
            model={model}
            history={history}
        />

    )

}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        errorType: state.register.errorType, // y lo que retorna map, connect lo envia a Page como Props 
        success: state.register.success,
    }
}


export default connect(mapStateToProps, { sendEmail })(RegisterEmail)

